import { toString } from 'lodash';

import {
    DROPDOWN_STATE,
    SELECT_INSURANCE_PLAN,
    SELECT_INSURANCE_CARRIER,
    TAB_SELECTION,
    TEXTBOX_CHANGE,
    REGISTER_CALLBACK,
    REGISTER_GA_CATEGORY,
    REGISTER_LOGGING_SECTION,
    SHOW_ALL_ITEMS,
    REGISTER_TRACKING,
    REGISTER_AWSURL,
    REGISTER_CLEARDATA_URL,
    TAB_CHANGE_MARKED,
    OPEN_MARKED,
    CHANGE_FOCUS,
    SET_DIRECTORY,
    SET_SHOW_SCAN_INSURANCE_CARD_BUTTON,
    SET_SCAN_CARD_ATTEMPTED,
    SET_SHOW_SCAN_INSURANCE_ERROR_MODAL,
    OPEN_SCAN_CARD,
    CLOSE_SCAN_CARD,
    REGISTER_RECORD_AB_PLAN_CHOSEN_BY_USER,
    REGISTER_RECORD_AB_CARRIER_CHOSEN_BY_USER,
} from './dropdownStateActions';

import { AUTOCOMPLETE_SUCCESS, TAB, InsuranceFormActions, CARRIER } from '../../constants';

const emptyFunc = () => { };
export const InitialState = {
    isOpen: false,
    isScanCardOpen: false,
    tab: TAB.INSURANCE,
    typedValue: '',
    hasBeenOpened: false,
    searchItems: null,
    showAll: { },
    gaCategory: 'Insurance Picker',
    successCallback: emptyFunc,
    carrierCallback: emptyFunc,
    clearValuesCallback: emptyFunc,
    clearedCarrier: false,
    focusIndex: 0,
    lastTab: null,
    showScanInsuranceCardButton: false,
    showScanInsuranceCardErrorModal: false,
    scanCardAttempted: false,
    AWS_API_HOST: null,
    CLEARDATA_API_HOST: null,
    recordAbCarrierChosenByUser: emptyFunc,
    recordAbPlanChosenByUser: emptyFunc,
};

export function dropdownStateReducer(state, action) {
    const {
        type,
        payload,
    } = action;

    state = state || InitialState;

    switch (type) {
        case REGISTER_CALLBACK:
            return {
                ...state,
                successCallback: payload.successCallback || emptyFunc,
                carrierCallback: payload.carrierCallback || emptyFunc,
                clearValuesCallback: payload.clearValuesCallback || emptyFunc,
            };

        case CHANGE_FOCUS:
            return {
                ...state,
                focusIndex: payload.nextFocusIndex,
            };

        case SET_DIRECTORY:
            return {
                ...state,
                directoryId: toString(payload),
            };

        case REGISTER_GA_CATEGORY:
            return {
                ...state,
                gaCategory: payload,
            };

        case REGISTER_LOGGING_SECTION:
            return {
                ...state,
                section: payload,
            };

        case REGISTER_AWSURL:
            return {
                ...state,
                AWS_API_HOST: payload,
            };

        case REGISTER_RECORD_AB_PLAN_CHOSEN_BY_USER:
            return {
                ...state,
                recordAbPlanChosenByUser: payload,
            };

        case REGISTER_RECORD_AB_CARRIER_CHOSEN_BY_USER:
            return {
                ...state,
                recordAbCarrierChosenByUser: payload,
            };

        case REGISTER_CLEARDATA_URL:
            return {
                ...state,
                CLEARDATA_API_HOST: payload,
            };

        case TAB_CHANGE_MARKED:
            return {
                ...state,
                tabChange: false,
            };

        case OPEN_MARKED:
            return {
                ...state,
                isOpening: false,
            };

        case REGISTER_TRACKING:
            return {
                ...state,
                tracking: payload,
            };

        case SHOW_ALL_ITEMS: {
            const newState = { ...state };
            newState.showAll[payload.tab] = payload.shouldShow;
            return newState;
        }

        case DROPDOWN_STATE:
            return {
                ...state,
                isOpen: payload.isOpen,
                hasBeenOpened: true,
                isOpening: payload.isOpen,
                clearedCarrier: false,
                focusIndex: 0,
                searchItems: null,
                typedValue: '',
                lastTab: null,
                isScanCardOpen: false,
                scanCardAttempted: false,
            };

        case OPEN_SCAN_CARD:
            return {
                ...state,
                isScanCardOpen: true,
            };

        case CLOSE_SCAN_CARD:
            return {
                ...state,
                isScanCardOpen: false,

            };

        case SELECT_INSURANCE_PLAN:
            return {
                ...state,
                plan: payload.plan,
                typedValue: '',
                searchItems: null,
            };

        case SELECT_INSURANCE_CARRIER:
            return {
                ...state,
                carrier: payload.carrier,
                typedValue: '',
                searchItems: null,
            };

        case TAB_SELECTION:
            return {
                ...state,
                ...payload,
                showAll: { },
                focusIndex: 0,
                lastTab: state.tab,
            };

        case AUTOCOMPLETE_SUCCESS:
            return {
                ...state,
                searchItems: payload.result,
            };

        case TEXTBOX_CHANGE:
            return {
                ...state,
                lastTab: null,
                typedValue: payload.typedValue,
                searchItems: payload.typedValue
                                && payload.typedValue.length > 1
                    ? state.searchItems : null,
            };

        case InsuranceFormActions.REQUEST_CARRIERS_SUCCEEDED: {
            let { carrier } = state;
            if (carrier && carrier.id && payload.carriers) {
                if (carrier.id !== CARRIER.IM_PAYING_MYSELF && carrier.id !== CARRIER.ILL_CHOOSE_LATER) {
                    carrier = payload.carriers.find(currentCarrier => currentCarrier.id === carrier.id) || null;
                }
            }
            return {
                ...state,
                carrier,
            };
        }

        case InsuranceFormActions.REQUEST_PLANS_SUCCEEDED: {
            let { plan } = state;
            if (plan && plan.id && payload.plans) {
                plan = payload.plans.find(currentPlan => currentPlan.id === plan.id) || plan;
            }

            return {
                ...state,
                plan,
            };
        }

        case SET_SHOW_SCAN_INSURANCE_CARD_BUTTON:
            return {
                ...state,
                showScanInsuranceCardButton: payload,
            };

        case SET_SCAN_CARD_ATTEMPTED:
            return {
                ...state,
                scanCardAttempted: true,
            };

        case SET_SHOW_SCAN_INSURANCE_ERROR_MODAL:
            return {
                ...state,
                showScanInsuranceCardErrorModal: payload.shouldShow,
            };

        default:
            return state;
    }
}
